import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MergeImagesListImageScreen from "./MergeImagesListImageScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function MergeImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Merge Images & Tile Images" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/merge_images", title: "Combine Images Free" },
    data2: { link: "/merge_images", title: "Photo Merger Online" },
    data3: { link: "/merge_images", title: "Image Merger Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Merge images online easily. Combine multiple photos into one image quickly with our fast, secure, and user-friendly image merger tool."
      ></meta>
      <meta
        name="keywords"
        content="merge images, image merger, combine images, merge photos online, photo merger, combine photos, image combiner, online image merger, merge images online, photo combine tool, merge pictures, join images online, image stitching tool, merge images free, image editor online, photo merger online, tile images, image tiler, arrange images side by side online, print multiple images in a single sheet, image grid online, image grid maker,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <MergeImagesListImageScreen title={title}></MergeImagesListImageScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Merge Images website provides a simple, fast, and reliable way to combine multiple images into a single image file with perfect alignment and high quality. Designed for ease of use, this powerful tool allows users to merge photos horizontally or vertically, create image collages, and combine images for documents, presentations, or social media content. Whether you want to join screenshots, stitch photos, or combine product images, this platform works efficiently as a modern image merger for everyday needs. Users can access the tool online, making it a flexible photo merger online and merge photos online solution that works across devices without complex software installation. Supporting popular formats such as JPG, PNG, and WebP, the website ensures original image quality is preserved during merging. With an intuitive interface and fast processing, users can upload images, arrange order, set spacing, and download the merged image instantly. Ideal for students, designers, professionals, and content creators, this image merger helps save time and improve workflow efficiency. If you are looking for a reliable merge images tool, an easy to use photo merger online, or a high-quality merge photos online solution, this website offers efficient way to combine images effortlessly." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Merge",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Merge Images Tool"
            why_use={[
              {
                title: "Combine Multiple Images into One",
                description:
                  "Our merge images tool allows users to combine multiple photos into a single image file. Using this photo merger online or image merger makes it easy to join screenshots and photos.",
              },
              {
                title: "Save Time and Boost Productivity",
                description:
                  "Merge photos online tools combine images instantly without manual editing, helping students, professionals, and creators save time.",
              },
              {
                title: "Perfect for Documents and Presentations",
                description:
                  "Our merge images tool helps organize visuals by combining multiple images into one for reports, presentations, and PDFs.",
              },
              {
                title: "Easy Online Access Without Installation",
                description:
                  "With a photo merger online, users can merge images directly in the browser without installing any software.",
              },
              {
                title: "Preserve Original Image Quality",
                description:
                  "High-quality image merger tools maintain resolution and clarity while merging images for professional results.",
              },
              {
                title: "Useful for Social Media and Marketing",
                description:
                  "Merge photos online tools are widely used to create collages, banners, and marketing visuals for social media platforms.",
              },
              {
                title: "Flexible Layout and Merge Options",
                description:
                  "Our modern merge images tool supports vertical, horizontal, and custom layouts, giving users control over image arrangement.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Most image merger tools support JPG, PNG, WebP, and other popular formats for flexible image merging.",
              },
              {
                title: "Beginner-Friendly and Fast",
                description:
                  "Our photo merger online offers a simple interface that allows users to merge images quickly without design or technical skills.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I merge images online for free?",
                description:
                  "You can merge images using an online image merging tool. Select the images you want to combine, arrange them in your preferred order, choose a layout if available, and download the merged image."
              },
              {
                title: "What is an image merger?",
                description:
                  "An image merger is a tool that combines two or more images into one image. It can help you create side-by-side comparisons, photo collages, before-and-after pictures, and combined image layouts."
              },
              {
                title: "Can I merge images offline?",
                description:
                  "Yes, if the image merging tool supports offline processing. A browser-based tool that processes images locally can combine files on your device after the website and required resources have loaded."
              },
              {
                title: "Does ShivaPDF merge images locally in my browser?",
                description:
                  "Local image processing means your images are combined directly in your browser instead of being uploaded to a server. Check that the Merge Images tool on ShivaPDF.com supports local processing before using it for private images."
              },
              {
                title: "Is it safe to merge images online?",
                description:
                  "Image merging can be safe when you use a trustworthy tool and understand how your files are processed. For sensitive photos or documents, consider a tool that processes images locally without uploading them to a server."
              },
              {
                title: "Can I merge images without uploading them?",
                description:
                  "Yes, when the tool performs all image processing locally in your browser. In that case, the selected images can remain on your device instead of being sent to a remote server. Confirm that the tool supports this before using it."
              },
              {
                title: "Can I combine multiple images into one?",
                description:
                  "Yes, image merging tools can combine multiple pictures into a single image. The number of images you can combine may depend on the tool, image dimensions, file sizes, and your device's available memory."
              },
              {
                title: "Can I merge images side by side?",
                description:
                  "Yes, a side-by-side layout places images next to each other in one combined image. This is useful for photo comparisons, product images, screenshots, and before-and-after pictures."
              },
              {
                title: "Can I merge images vertically?",
                description:
                  "A vertical layout stacks images from top to bottom in a single image. It is useful for combining screenshots, receipts, long visual guides, and other images that work well in a vertical sequence."
              },
              {
                title: "Can I merge images horizontally?",
                description:
                  "A horizontal layout places images next to each other in one row. It is useful for creating panoramic-style compositions, comparisons, and combined product or travel photos."
              },
              {
                title: "Which image formats can I merge?",
                description:
                  "Supported formats depend on the image merging tool and browser. Common web image formats include JPG, JPEG, PNG, and WebP. Check the tool's supported formats before selecting your files."
              },
              {
                title: "Can I merge JPG images into one image?",
                description:
                  "Yes, if JPG or JPEG files are supported by the tool, you can combine multiple JPG images into a single image. The final output format depends on the export options provided."
              },
              {
                title: "Can I merge PNG images without losing transparency?",
                description:
                  "PNG supports transparent backgrounds, but transparency in the merged result depends on the selected output format and how the tool handles transparent pixels. Choose PNG output if you need transparency to be preserved."
              },
              {
                title: "Will merging images reduce their quality?",
                description:
                  "Image quality depends on the output dimensions, file format, and compression settings. For better results, choose suitable output dimensions and use a format and quality setting appropriate for your images."
              },
              {
                title: "Can I adjust the spacing between merged images?",
                description:
                  "Some image merging tools let you adjust the spacing, margins, or background between images. Available layout controls depend on the features provided by the tool."
              },
              {
                title: "Can I change the order of images before merging?",
                description:
                  "If the tool supports image reordering, you can arrange your pictures before combining them. Review the order carefully so the final image displays your pictures in the intended sequence."
              },
              {
                title: "Can I merge images on my mobile phone?",
                description:
                  "You can merge images on an Android phone, iPhone, or tablet using a compatible browser-based tool. Mobile performance may depend on the number of images, their dimensions, and the device's available memory."
              },
              {
                title: "Can I merge images on Windows and Mac?",
                description:
                  "Yes, you can use a browser-compatible image merging tool on Windows or macOS. If the tool supports local processing, image merging can take place directly in the browser without installing separate software."
              },
              {
                title: "Do I need to install software to merge images?",
                description:
                  "A browser-based image merger can let you combine pictures without installing a separate application. You only need a supported browser and access to the tool, unless its offline requirements specify otherwise."
              },
              {
                title: "Can I merge screenshots into one image?",
                description:
                  "Yes, combining screenshots into one image is useful for tutorials, conversations, step-by-step instructions, and long-page references. Choose a horizontal or vertical layout based on how you want the screenshots to appear."
              },
              {
                title: "Can I merge photos into a collage?",
                description:
                  "You can create a simple photo collage by combining multiple photos into one image. The final appearance depends on the layouts, spacing, alignment, and background options supported by the image merging tool."
              },
              {
                title: "Why is image merging taking a long time?",
                description:
                  "Large images and multiple high-resolution files require more memory and processing time. Try using fewer images at once, reducing their dimensions if appropriate, or closing other tabs and applications."
              },
              {
                title: "Why can't I download my merged image?",
                description:
                  "Check that image processing has finished and that your browser allows downloads. If the download fails, try merging the images again, check your available device storage, or use a supported browser."
              },
              {
                title: "Is the Merge Images tool on ShivaPDF free to use?",
                description:
                  "Visit the Merge Images page on ShivaPDF.com to check current availability, supported formats, and any usage or file-size limits. Features and restrictions depend on the tool's implementation."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default MergeImagesMain;
